module.exports = __webpack_public_path__ + "static/media/YM84_6.a357cd2c.jpg";